/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { translate } from '@utils/i18n';
// Import react-virtualized components
import { CellMeasurerCache } from 'react-virtualized';
import { IssueTypeEnum } from '../../types';
import IssueCard from '../IssueCard';
import './styles.scss';
// Component defined outside of render to avoid React reconciliation issues
function IssueRow(props) {
    const { issue, style, index, inspectionId, cache, readOnly = false, settings } = props;
    // Create a new style object that includes the original style plus marginBottom for gap
    const rowStyle = Object.assign(Object.assign({}, style), { paddingBottom: '16px' // Add 16px gap between items
     });
    return (React.createElement("div", { style: rowStyle },
        React.createElement(IssueCard, { key: issue.id, issue: issue, inspectionId: inspectionId, readOnly: readOnly, onIssueUpdated: () => {
                // When an issue is updated (e.g., note expanded), remeasure the row
                setTimeout(() => {
                    // Type-safe clear method call
                    if (cache) {
                        cache.clear(index, 0);
                    }
                }, 50);
            }, settings: settings })));
}
export default function SectionGroup({ group, inspectionId, readOnly = false, settings }) {
    const [isExpanded, setIsExpanded] = useState(true);
    const defaultHeight = useMemo(() => {
        let height = 151;
        if (group.issues.some((issue) => issue.issueType === IssueTypeEnum.AnalyzeDeficiencyNotes)) {
            height = 334;
        }
        else if (group.issues.some((issue) => issue.issueType === IssueTypeEnum.UnansweredQuestion)) {
            height = 150;
        }
        return height;
    }, [group]);
    // Create a cache for cell measurements with proper typing
    const cache = useRef(new CellMeasurerCache({
        fixedWidth: true,
        defaultHeight,
        minHeight: 100
    }));
    // Reset cache when dependencies change
    useEffect(() => {
        if (cache.current) {
            cache.current.clearAll();
        }
    }, [group, isExpanded]);
    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    return (React.createElement("div", { className: "section-group" },
        React.createElement("div", { className: "section-group__header", onClick: toggleExpanded, role: "button", tabIndex: 0, onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    toggleExpanded();
                    e.preventDefault();
                }
            }, "aria-expanded": isExpanded, "aria-label": isExpanded
                ? translate('collapse_section', { namespace: 'features.iim_review.section_group' })
                : translate('expand_section', { namespace: 'features.iim_review.section_group' }) },
            React.createElement("h3", { className: "section-group__title" }, group.title),
            React.createElement("div", { className: "line-separator" }),
            React.createElement("div", { className: "section-group__header__actions" },
                React.createElement("span", { className: "section-group__count" },
                    group.issues.length,
                    " ",
                    translate('unresolved_issues', { namespace: 'features.iim_review.section_group' })),
                React.createElement("span", { className: "section-group__toggle", "aria-label": isExpanded
                        ? translate('collapse_section', { namespace: 'features.iim_review.section_group' })
                        : translate('expand_section', { namespace: 'features.iim_review.section_group' }) }, isExpanded ? (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M4 10L8 6L12 10", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))) : (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M4 6L8 10L12 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })))))),
        isExpanded && (React.createElement("div", { className: "section-group__content" }, group.issues.map((issue) => (React.createElement(IssueRow, { key: issue.id, issue: issue, style: { paddingBottom: '16px' }, index: issue.id, inspectionId: inspectionId, cache: cache.current, readOnly: readOnly, settings: settings })))))));
}
